import { transparentize, mode } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { theme, colorScheme } = props;
    return {
        container: {
            verticalAlign: 'top',
            bg: mode(`${colorScheme}.400`, `${colorScheme}.300`)(props),
            borderColor: mode('white', 'gray.800')(props),
            color: mode('white', transparentize('black', 0.87)(theme))(props),
            fontWeight: 'bold',
        },
        badge: {
            transform: 'translate(25%, 25%)',
            borderRadius: 'full',
            border: '0.2em solid',
            borderColor: mode('white', 'gray.800')(props),
        },
        group: {
        // TODO: reverse overlapping
        },
    };
};
const parts = ['container', 'excessLabel', 'badge', 'label'];
const sizes = {
    sm: {
        container: {
            width: '1.875rem',
            height: '1.875rem',
            fontSize: 'sm',
        },
        label: {
            fontSize: 'sm',
            lineHeight: 'none',
        },
    },
    md: {
        container: {
            width: '2.25rem',
            height: '2.25rem',
            fontSize: 'md',
        },
        label: {
            fontSize: 'md',
            lineHeight: 'none',
        },
    },
    lg: {
        container: {
            width: '3rem',
            height: '3rem',
            fontSize: '2xl',
        },
        label: {
            fontSize: '2xl',
            lineHeight: 'none',
        },
    },
    xl: {
        container: {
            width: '4rem',
            height: '4rem',
            fontSize: '3xl',
        },
        label: {
            fontSize: '3xl',
            lineHeight: 'none',
        },
    },
};
const defaultProps = {
    size: 'md',
    colorScheme: 'gray',
};
export default {
    parts,
    baseStyle: getBaseStyle,
    sizes,
    defaultProps,
};
//# sourceMappingURL=avatar.js.map